import styled from "styled-components";

export const BoxEspecialidade = styled.div`
  width: 50%;

  & + & {
    // border-left: solid 1px darkgray;
    padding-left: 1rem;
  }
`;
